import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import server_45to_45server_45global from "/app/middleware/server-to-server.global.ts";
import token_45auth_45global from "/app/middleware/token-auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  server_45to_45server_45global,
  token_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}